
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.024 16.7l3.363-2.572a5.934 5.934 0 01-.296-1.86c0-.65.104-1.274.296-1.858L3.024 7.838A10.009 10.009 0 002 12.268c0 1.595.368 3.098 1.024 4.432z","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M6.387 10.41A5.898 5.898 0 0112 6.36c1.41 0 2.682.5 3.682 1.319l2.909-2.91c-1.773-1.545-4.046-2.5-6.591-2.5a9.97 9.97 0 00-8.976 5.57l3.363 2.572z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M12 22.27A9.97 9.97 0 013.023 16.7l3.361-2.578A5.898 5.898 0 0012 18.18c1.285 0 2.423-.303 3.325-.872l3.193 2.472c-1.748 1.625-4.079 2.49-6.518 2.49z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M12 10.451h9.318a8.3 8.3 0 01.227 1.818c0 3.26-1.192 5.804-3.027 7.51l-3.193-2.472c1.044-.659 1.77-1.675 2.039-2.992H12V10.45z","fill":"#4285F4"}})])
          )
        }
      }
    